/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Correlation_Not_AvailableInputs */

const en_admin_statistics_correlation_not_available = /** @type {(inputs: Admin_Statistics_Correlation_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no applications with a calculated matching score in the selected period.`)
};

const de_admin_statistics_correlation_not_available = /** @type {(inputs: Admin_Statistics_Correlation_Not_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den gewählten Zeitraum liegen keine Bewerbungen mit berechnetem Matching Score vor.`)
};

/**
* | output |
* | --- |
* | "There are no applications with a calculated matching score in the selected period." |
*
* @param {Admin_Statistics_Correlation_Not_AvailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_correlation_not_available = /** @type {((inputs?: Admin_Statistics_Correlation_Not_AvailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Correlation_Not_AvailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_correlation_not_available(inputs)
	return en_admin_statistics_correlation_not_available(inputs)
});